import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { AffiliateCodeModal } from './AffiliateCodeModal';
import SettingsIcon from '../CustomSVGIcons/SettingsIcon';
import { AffiliateListModal } from './AffiliateListModal';

export const AffiliateCode: React.FC = () => {
    const { themeStyle } = useThemeContext();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);

    return (
        <>
            <Box
                style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                sx={{
                    backgroundColor: theme[themeStyle].secondaryBg,
                    borderRadius: '10px',
                    width: '100%',
                    height: '100%',
                    padding: '24px',
                    minHeight: '200px',
                    position: 'relative',
                    boxShadow: `0px 0px 3px ${theme[themeStyle].gray_sidebar}`,
                    mt: 2,
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme[themeStyle].secondaryBg,
                        transform: 'translateY(-2px)',
                        transition: 'all 0.2s ease-in-out',
                    },
                }}
                onClick={() => setShowCreateModal(true)}>
                {/* Settings Icon */}
                <IconButton
                    onClick={e => {
                        e.stopPropagation();
                        setShowListModal(true);
                    }}
                    sx={{
                        position: 'absolute',
                        right: 5,
                        top: 5,
                        color: theme[themeStyle].grey,
                        '&:hover': {
                            color: theme[themeStyle].highlight,
                        },
                    }}>
                    <SettingsIcon stroke={theme[themeStyle].grey} width="20px" height="20px" />
                </IconButton>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingBottom: '8px',
                    }}>
                    <Typography
                        style={{
                            fontSize: 14,
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            color: theme[themeStyle].form_label,
                        }}>
                        Affiliate Codes
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                    }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                        <Typography
                            style={{
                                fontSize: 24,
                                fontWeight: '500',
                                fontFamily: FONT_ENUM.MAIN_BOLD,
                                color: theme[themeStyle].filters_white,
                            }}>
                            Manage
                        </Typography>
                        <Typography
                            style={{
                                fontSize: 14,
                                fontWeight: '200',
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                color: theme[themeStyle].grey,
                            }}>
                            Create and manage affiliate codes
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Create Affiliate Modal */}
            <AffiliateCodeModal open={showCreateModal} onClose={() => setShowCreateModal(false)} />

            {/* Affiliate List Modal */}
            <AffiliateListModal open={showListModal} onClose={() => setShowListModal(false)} />
        </>
    );
};
